import React from 'react';
import Ternary from '@/components/Tenary';
import { QUERY_KEYS } from '../../../../../type';
import { useAnnotatedTaskId } from '@/pages/CustomCenter/ExtractConfig/stores';
import { useTab } from '@/pages/CustomCenter/ExtractConfig/stores/useTab';
import { Button } from '@ai-indeed/idp-ui';
import { useQuery, useQueryClient, useSearchParams } from '@umijs/max';
import { message, Progress, Spin } from 'antd';
import { FC, useMemo } from 'react';
import * as NodeAPI from '../service';
const useAnnotationData = (props: {
  template_code: string;
  node_uid: string;
}) => {
  // const queryKey = useMemo(() => {}, [props.node_uid, props.template_code]);

  const queryKey = NodeAPI.getNlpNodeAnnotationTaskOverview.queryKey({
    template_code: props.template_code,
    node_uid: props.node_uid,
  });

  const query = useQuery({
    queryKey: [QUERY_KEYS.WORKFLOW_CONFIG, ...queryKey],
    queryFn: () => {
      return NodeAPI.getNlpNodeAnnotationTaskOverview({
        template_code: props.template_code,
        node_uid: props.node_uid,
      });
    },
    select: (data) => data?.[0],
    refetchOnWindowFocus: false,
  });

  return { ...query, queryKey };
};

export default useAnnotationData;
